var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-bubble',{attrs:{"isMine":_vm.isMine}},[_c('div',{staticClass:"face-element-wrapper"},[_c('img',{attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }